// 菜单列表数据

const pcMenuList = [
  {
    name: 'currency.myProduct',
    path: '',
    icon: 'icon-a-shopping-bag-3-line2',
    children: [
      { name: 'currency.listings', path: '/publish/listings' },
      { name: 'currency.myDesign', path: '/publish/userDesign' },
      { name: 'currency.wishList', path: '/publish/productList' },
      // { name: 'batchTasks.batchTasks', path: '/publish/batchTasks' },
      { name: 'currency.customProduct', path: '/commodity/customProduct/list' }
    ]
  },
  {
    name: 'currency.allOrder',
    path: '/order/list',
    icon: 'icon-a-file-list-line1'
  },
  {
    name: 'currency.RefundingOrder',
    path: '/order/sales',
    icon: 'icon-exchange-box-line'
  },

  // {
  //   name: 'currency.customOrders',
  //   path: '/order/custom',
  //   icon: 'icon-draft-line'
  // },
  {
    name: 'currency.customOrders',
    path: '',
    icon: 'icon-draft-line',
    children: [
      { name: 'currency.customSamples', path: '/order/custom-samples' },
      { name: 'currency.customOrders', path: '/order/custom-order' },
      { name: 'currency.fabricLibrary', path: '/order/custom-fabric-library' },
      { name: 'currency.customPrinting', path: '/order/custom-printing' }
    ]
  },
  {
    name: 'currency.billingStatement', // 账期管理
    path: '/billing',
    icon: 'icon-file-list-3-line'
  },

  {
    name: 'currency.store',
    path: '/personal-center/store-manage',
    icon: 'icon-store-line'
  },
  {
    name: 'currency.personalCenter',
    path: '',
    icon: 'icon-settings-line',
    children: [
      { name: 'currency.payment', path: '/personal-center/payment-manage' },

      { name: 'currency.coupons', path: '/personal-center/coupons' },

      { name: 'currency.address', path: '/personal-center/address-manage' },
      { name: 'currency.accountSettings', path: '/personal-center/account-setting' },
      { name: 'myInformation.myInformation', path: '/personal-center/my-information' },
      { name: 'API', path: '/personal-center/api-setting' }
    ]
  }
]
const mobileMenuList = [
  {
    name: 'currency.myProduct',
    path: '',
    // icon: 'icon-a-shopping-bag-3-line2',
    children: [
      { name: 'currency.listings', path: '/publish/listings' },
      { name: 'currency.wishList', path: '/publish/productList' }
    ]
  },
  {
    name: 'currency.allOrder',
    path: '/order/list'
    // icon: 'icon-a-file-list-line1'
  },
  {
    name: 'currency.store',
    path: '/personal-center/store-manage'
    // icon: 'icon-store-line'
  },
  {
    name: 'currency.address',
    path: '/personal-center/address-manage'
    // icon: 'icon-store-line'
  },
  {
    name: 'currency.personalCenter',
    path: '',
    // icon: 'icon-settings-line'
    children: [
      { name: 'currency.coupons', path: '/personal-center/coupons' },
      // { name: 'currency.payment', path: '/personal-center/payment-manage' },
      { name: 'currency.accountSettings', path: '/personal-center/account-setting' }
    ]
  }
]

exports.pcMenuList = pcMenuList
exports.mobileMenuList = mobileMenuList
